module.exports = __webpack_public_path__ + "static/media/logo.36cb0813.svg";